"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _UIModal = _interopRequireDefault(require("UIComponents/dialog/UIModal"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIDialogBody = _interopRequireDefault(require("UIComponents/dialog/UIDialogBody"));

var _UIDialogHeaderImage = _interopRequireDefault(require("UIComponents/dialog/UIDialogHeaderImage"));

var _UIDialogFooter = _interopRequireDefault(require("UIComponents/dialog/UIDialogFooter"));

var SuccessModal = function SuccessModal(_ref) {
  var header = _ref.header,
      footer = _ref.footer;
  return _react.default.createElement(_UIModal.default, {
    centered: true,
    use: "success",
    width: 600
  }, _react.default.createElement(_UIDialogBody.default, null, _react.default.createElement(_UIDialogHeaderImage.default, {
    offsetBottom: 23,
    offsetTop: 99
  }, _react.default.createElement(_UIIllustration.default, {
    name: "success",
    width: 118
  })), _react.default.createElement("h2", null, header)), _react.default.createElement(_UIDialogFooter.default, null, footer));
};

SuccessModal.propTypes = {
  header: _react.PropTypes.node,
  footer: _react.PropTypes.node
};
var _default = SuccessModal;
exports.default = _default;
module.exports = exports.default;